import { TenantOrderLine } from '~/lib/model';
import Big from 'big.js';
import { FIRST_VERSION_TIMESTAMP, ZodVersionedMetadata } from '~/lib/zod';
import MpiJob from '../../model/MpiJob';
import Mpi3dConfig, { Mpi3dType } from '~/tenants/mpi/performable/3d/Mpi3dConfig';
import { DeliverableType } from '~common/model/Deliverable';
import { PersonaType } from '~/tenants/common/TenantPersona';

export default class Mpi3dJob extends MpiJob<typeof Mpi3dConfig> {
  defaultValue(): ZodVersionedMetadata<(typeof Mpi3dConfig)['schema']> {
    return {
      version: FIRST_VERSION_TIMESTAMP,
      type: Mpi3dType.IGUIDE,
    };
  }

  onsite() {
    if (this.order.metadata.sqft > 7000) {
      return 180;
    }

    if (this.order.metadata.sqft > 5000) {
      return 120;
    }

    if (this.order.metadata.sqft > 3000) {
      return 90;
    }

    return 60;
  }

  get submitter() {
    return PersonaType.OFFICE;
  }

  get deliverable() {
    return this.metadata.type === Mpi3dType.IGUIDE ? DeliverableType.IGUIDE : DeliverableType.MATTERPORT;
  }

  get performable() {
    return Mpi3dConfig;
  }

  get configurable() {
    return true;
  }

  revenueLines(): TenantOrderLine[] {
    const lines = super.revenueLines();

    const type = this.metadata.type === Mpi3dType.MATTERPORT ? 'Matterport' : 'IGuide';
    const basePrice = new Big(this.metadata.type === Mpi3dType.IGUIDE ? 175 : 200);
    const pricePer500Sqft = this.metadata.type === Mpi3dType.IGUIDE ? '0.0475' : '0.05';

    const sqftPrice = new Big(Math.max(0, this.order.metadata.sqft - 2000)).round(0, 0).times(pricePer500Sqft);

    lines.push({
      amount: basePrice.plus(sqftPrice),
      description: `3D ${type}`,
      id: '3d',
    });

    return lines;
  }
}
